export const ANALYTICS_TABS = [
  {
    slug: "batch-capacity",
    label: "Batch Capacity",
    path: "/admin/analytics/batch-capacity",
    breadcrumb: "Batch Capacity",
  },
  {
    slug: "course-content",
    label: "Course Content",
    path: "/admin/analytics/course-content",
    breadcrumb: "Course Content",
  },
  {
    slug: "payment-overdue",
    label: "Fee Alerts",
    path: "/admin/analytics/payment-overdue",
    breadcrumb: "Fee Alerts",
  },
  {
    slug: "academic-support",
    label: "Student Performance",
    path: "/admin/analytics/academic-support",
    breadcrumb: "Student Performance",
  },
  {
    slug: "weak-topics",
    label: "Weak Topics",
    path: "/admin/analytics/weak-topics",
    breadcrumb: "Weak Topics",
  },
  {
    slug: "target-schools",
    label: "Target Schools",
    path: "/admin/analytics/target-schools",
    breadcrumb: "Target Schools",
  },
  {
    slug: "revision-planning",
    label: "Revision Analytics",
    path: "/admin/analytics/revision-planning",
    breadcrumb: "Revision Analytics",
  },
  {
    slug: "coverage",
    label: "Consortium Coverage",
    path: "/admin/analytics/coverage",
    breadcrumb: "Consortium Coverage",
  },
  {
    slug: "geographic",
    label: "Geographical Insights",
    path: "/admin/analytics/geographic",
    breadcrumb: "Geographical Insights",
  },
  {
    slug: "app-usage",
    label: "App Engagement",
    path: "/admin/analytics/app-usage",
    breadcrumb: "App Engagement",
  },
  {
    slug: "ai-usage",
    label: "AI Usage",
    path: "/admin/analytics/ai-usage",
    breadcrumb: "AI Usage",
  },
  {
    slug: "notifications",
    label: "Notifications",
    path: "/admin/analytics/notifications",
    breadcrumb: "Notifications",
  },
];

// Top tabs inside Analytics > Marketing (rendered by MarketingLayout). The first tab is the
// index route; breadcrumb null means the crumb stays "Marketing".
export const MARKETING_TABS = [
  { slug: "overview", label: "Overview", path: "/admin/analytics/marketing", breadcrumb: null },
  {
    slug: "competitors",
    label: "Competitors",
    path: "/admin/analytics/marketing/competitors",
    breadcrumb: "Competitors",
  },
];

// Marketing is its own sidebar item (Analytics > Marketing), so it is not a tab here
// and AnalyticsLayout hides the tab bar on its page.
export const STANDALONE_ANALYTICS_PAGES = [
  { path: "/admin/analytics/marketing", breadcrumb: "Marketing", subTabs: MARKETING_TABS },
];

// Index of the active sub-tab: the first tab is the base path and the fallback.
export function subTabIndexByPath(tabs, pathname) {
  const path = pathname.replace(/\/+$/, "");
  const idx = tabs.findIndex(
    (t, i) => i > 0 && (path === t.path || path.startsWith(`${t.path}/`))
  );
  return idx === -1 ? 0 : idx;
}

export function marketingTabIndexByPath(pathname) {
  return subTabIndexByPath(MARKETING_TABS, pathname);
}

export function analyticsTabByPath(pathname) {
  return ANALYTICS_TABS.find((t) => pathname === t.path || pathname.startsWith(`${t.path}/`))
    || ANALYTICS_TABS[0];
}
